module.exports = __webpack_public_path__ + "static/img/bgNew.3b95698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bgNew.jpg
// module id = IYjk
// module chunks = 1